import React from 'react';



import Navbar from '../Navbar/Navbar';






const Header = () => {
    return (
        <div>

            <div>
                <h1 className='text-6xl mb-3 bg-red-50'> Tutor Academy</h1>
                <Navbar></Navbar>





            </div>

        </div>






    );
};

export default Header;